import { render, staticRenderFns } from "./form-queries-header.vue?vue&type=template&id=2b02dff6&scoped=true&"
import script from "./form-queries-header.vue?vue&type=script&lang=js&"
export * from "./form-queries-header.vue?vue&type=script&lang=js&"
import style0 from "./form-queries-header.vue?vue&type=style&index=0&id=2b02dff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b02dff6",
  null
  
)

component.options.__file = "form-queries-header.vue"
export default component.exports